/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { ApiCustomErrorCode, ErrorDefaultCodeEnum } from 'client-code/action-details';
import { AppError } from './AppError';
import { ErrorTypes } from './ErrorTypes';
import { Locale } from '../locale/Locale';
import { LocaleKeys } from '../locale/LocaleKeys';

export class OfferActionDetailsError extends AppError {
    TAG: string = 'OfferActionDetailsError';

    protected title: string = Locale.getString(LocaleKeys.SOCU_ERROR_OVERLAY_TITLE);

    protected type: string;

    constructor(code: string, message: string, description: string) {
        super(code, message);
        this.message = message;
        this.description = description;
        this.type = code;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ApiCustomErrorCode.ApigwError:
            case ErrorDefaultCodeEnum.ApigwError:
                this.code = ErrorTypes.OTT_OFFER_ACTION_DETAILS_APIGW_ERROR_V301;
                break;
            case ApiCustomErrorCode.BadRequest:
                this.code = ErrorTypes.OTT_OFFER_ACTION_DETAILS_BAD_REQUEST_V302;
                break;
            case ApiCustomErrorCode.DataNotFound:
                this.code = ErrorTypes.OTT_OFFER_ACTION_DETAILS_DATA_NOT_FOUND_V303;
                break;
            case ApiCustomErrorCode.DeviceInfoNotFound:
                this.code = ErrorTypes.OTT_OFFER_ACTION_DETAILS_DEVICE_INFO_NOT_FOUND_V304;
                break;
            case ApiCustomErrorCode.DynamoDbError:
                this.code = ErrorTypes.OTT_OFFER_ACTION_DETAILS_DYNAMO_DB_ERROR_V305;
                break;
            case ApiCustomErrorCode.InternalServerError:
                this.code = ErrorTypes.OTT_OFFER_ACTION_DETAILS_INTERNAL_SERVER_ERROR_V307;
                break;
            case ApiCustomErrorCode.PartnerInfoNotFound:
                this.code = ErrorTypes.OTT_OFFER_ACTION_DETAILS_PARTNER_INFO_NOT_FOUND_V308;
                break;
            case ApiCustomErrorCode.UnexpectedError:
                this.code = ErrorTypes.OTT_OFFER_ACTION_DETAILS_UNEXPECTED_ERROR_V309;
                break;
            default:
                this.code = ErrorTypes.OTT_OFFER_ACTION_DETAILS_UNKNOWN_ERROR_V399;
                this.type = 'OTT_OFFER_ACTION_DETAILS_UNKNOWN_ERROR';
        }
    }

    public getTitle(): string {
        return this.title;
    }

    public getType(): string {
        return this.type;
    }
}
